import { Primary } from "../buttons/Primary";
import { motion } from "framer-motion";
import { CheckCircleIcon } from "@heroicons/react/20/solid";

const features = [
  {
    description: "Solo necesitas tu cédula y WhatsApp",
  },
  {
    description: "Somos miembros de Colombia Fintech",
  },
  {
    description: "Cobranza respetuosa y amable",
  },
  {
    description: "Tratamos tus datos con base a la ley vigente",
  },
];

export function FacebookHero() {
  return (
    <div className="bg-tdark overflow-hidden pt-10 font-walsheim">
      <div className="pb-8 sm:pb-12">
        <main className="mt-16 sm:mt-18">
          <div className="mx-auto max-w-7xl">
            <div className="lg:flex md:py-16 md:pt-20">
              <div className="md:hidden relative block py-10 lg:w-1/2">
                <motion.div
                  initial={{ x: 100, opacity: 0.4 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ ease: "easeOut", duration: 2 }}
                  className="z-10"
                >
                  <div className="grid justify-items-center block h-auto">
                    <img
                      className="w-60 h-auto"
                      src="/png/man-fresh-phone.png"
                      alt="Crear-cuenta"
                    />
                  </div>
                </motion.div>
              </div>
              <div className="px-4 text-white sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
                <motion.div
                  initial={{ y: 100, opacity: 0.4 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ ease: "easeOut", duration: 2 }}
                  className="z-10"
                >
                  <h1 className="text-center md:text-left mt-4 text-4xl tracking-tight font-bold sm:mt-5 sm:leading-none lg:mt-6 lg:text-5xl xl:text-6xl">
                    <span className="md:block">
                      Crédito 100% digital en Colombia hasta $500.000 por
                      primera vez
                    </span>{" "}
                  </h1>
                  <div className="text-center font-light md:text-left md:pr-10 py-8 text-lg">
                    <ul>
                      {features.map((feature) => (
                        <div className="flex">
                          <div>
                            <CheckCircleIcon
                              className="text-white h-5 w-5"
                              aria-hidden="true"
                            />
                          </div>
                          <li key={feature.name} className="pl-1 text-left">
                            <dd>{feature.description}</dd>
                          </li>
                        </div>
                      ))}
                    </ul>
                  </div>
                  <div className="md:w-1/3">
                    <a href="https://galilea.co/?utm_source=paga&utm_medium=web&utm_campaign=cpa&utm_id=facebook_ads&utm_term=leads">
                      <Primary text="Calcular mi crédito" />
                    </a>
                  </div>
                </motion.div>
              </div>
              <motion.div
                initial={{ x: 100, opacity: 0.4 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ ease: "easeOut", duration: 2 }}
                className="z-10 relative block py-10 lg:w-1/2"
              >
                <div className="">
                  <div className="hidden md:block lg:absolute lg:w-120 h-auto lg:top-1/2 lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:-translate-y-1/2">
                    <img
                      className="w-110 h-auto"
                      src="/png/man-fresh-phone.png"
                      alt="Crear-cuenta"
                    />
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
